import { MenuItem } from "@mui/material";
import React, { type FC } from "react";
import { NavLink } from "react-router";

import { MoreButton } from "~/components/UI/MoreButton";
import { ROUTES } from "~/constants/routing";
import type { ICategory } from "~/types/category";

import * as Styled from "./MoreCategoriesButton.styles";

interface IMoreCategoriesButtonProps {
  categories: ICategory[];
  getIsActive: (_: string) => boolean;
}

export const MoreCategoriesButton: FC<IMoreCategoriesButtonProps> = ({
  categories,
  getIsActive,
}) => {
  return (
    <MoreButton text="More">
      {categories.map((category) => (
        <MenuItem
          key={category.id}
          component={NavLink}
          to={ROUTES.category.createURL(category.slug)}
          selected={getIsActive(category.slug)}
        >
          <Styled.CategoryText
            variant="caption"
            $isActive={getIsActive(category.slug)}
          >
            {category.name}
          </Styled.CategoryText>
        </MenuItem>
      ))}
    </MoreButton>
  );
};
